import { render } from "./changeprice.vue?vue&type=template&id=d41d746c"
import script from "./changeprice.vue?vue&type=script&lang=js"
export * from "./changeprice.vue?vue&type=script&lang=js"

import "./changeprice.vue?vue&type=style&index=0&id=d41d746c&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__